import { render, staticRenderFns } from "./ModalNewsLatterDone.vue?vue&type=template&id=8d0d9b18"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports